import ArchivePostSingle from './ArchivePostSingle';

export default ArchivePostSingle;
